import { render, staticRenderFns } from "./dashboardCoupon.vue?vue&type=template&id=65f51476&scoped=true"
import script from "./dashboardCoupon.vue?vue&type=script&lang=js"
export * from "./dashboardCoupon.vue?vue&type=script&lang=js"
import style0 from "./dashboardCoupon.vue?vue&type=style&index=0&id=65f51476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f51476",
  null
  
)

export default component.exports